<div class="dash">
    <app-loading-spinner [active]="loadingStatus"></app-loading-spinner>
    <div class="dash-card no-padding">
        <div class="dash-card-header d-block" style="flex-direction: column;">
            <div class="row no-gutters">
                <div class="col-12">
                    <div style="padding-bottom: 0;">
                        <div
                            class="d-flex justify-content-between align-items-center">
                            <div>
                                <h2>Controle de permissões</h2>
                                <p>Defina o que cada grupo pode acessar ou fazer
                                    na
                                    plataforma,
                                    de forma segura e organizada.</p>
                            </div>
                            <app-button (onClick)="addPermission()"
                                class="add-button"
                                *ngIf="permissionObj.canAdd && (loading || data.length > 0)">
                                <svg-icon src="assets/images/icon-add.svg"
                                    class="mr-2 mt-1 mb-1"></svg-icon>
                                Adicionar grupo de permissões
                            </app-button>
                        </div>
                    </div>
                </div>

                <div class="col-12 d-flex justify-content-between align-items-center mt-5 px-0"
                    *ngIf="loading || data.length > 0 || hasFilters">
                    <div class="d-flex align-items-center">
                        <button type="button" class="sort-button mr-2"
                            (click)="refreshData()" [disabled]="loading">
                            <svg-icon
                                src="assets/images/icon-renew.svg"></svg-icon>
                            <span>Atualizar</span>
                        </button>
                    </div>

                    <div class="d-flex align-items-center">
                        <app-button
                            *ngIf="hasFilters && permissionObj.canFilter && !loading"
                            [danger]="true" [outline]="true"
                            class="add-button mr-2" (onClick)="resetForm()">
                            <i
                                class="fas fa-times filter-clear-icon mt-1 mb-1"></i>
                            Limpar filtros
                        </app-button>

                        <app-button [inverted]="true" class="add-button mr-2"
                            (onClick)="showFilterModal = true"
                            [disabled]="loading"
                            *ngIf="permissionObj.canFilter && (loading || data.length > 0 || hasFilters)">
                            <svg-icon
                                src="assets/images/icon_filter.svg"></svg-icon>
                            {{ hasFilters ? 'Editar filtros' : 'Filtrar
                            listagem' }}
                        </app-button>
                    </div>
                </div>

                <div class="col-12 mt-3 px-0"
                    *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                    <div
                        class="d-flex flex-wrap align-items-center justify-content-end">
                        <app-filter-tag *ngFor="let filter of appliedFilters"
                            [label]="filter.label" [value]="filter.value">
                        </app-filter-tag>
                    </div>
                </div>
            </div>
        </div>

        <div class="dash-card-body padding-container"
            style="overflow: visible;">
            <ng-container *ngIf="loading">
                <table #table class="bordered">
                    <tbody>
                        <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '200px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '40px',
                                        marginBottom:'0',
                                        marginLeft: 'auto'
                                      }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '150px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                        height: '24px',
                                        width: '70px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <div
                                    style="display: flex; gap: 16px; justify-content: flex-end;">
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '16px',
                                        marginBottom:'0',
                                        borderRadius: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '16px',
                                        marginBottom:'0',
                                        borderRadius: '0'
                                      }">
                                    </ngx-skeleton-loader>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <table class="bordered" *ngIf="!loading && data.length > 0">
                <thead>
                    <tr>
                        <th>Grupo</th>
                        <th>Permissões associadas</th>
                        <!-- <th>Pessoas Associadas</th> -->
                        <th>Última atualização</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of data">
                        <td>{{item.group}}</td>

                        <td>
                            {{item.permissions}}
                        </td>

                        <!-- <td>{{item.users}}</td> -->

                        <td>
                            <div class="dash-card-item-content"
                                *ngIf="item.updated_at">
                                <div class="dash-card-item-content-title">
                                    {{displayDateTime(item.updated_at).date}}
                                </div>
                                <div class="dash-card-item-content-subtitle">
                                    {{displayDateTime(item.updated_at).time}}
                                </div>
                            </div>
                            <span *ngIf="!item.updated_at">-</span>
                        </td>

                        <td>
                            <div class="status-tag"
                                [class.-inactive]="item.status === 'Inativo'">
                                {{item.status}}</div>
                        </td>

                        <td>
                            <div class="dash-card-item-buttons">
                                <!-- <button class="dash-item-button"
                                    (click)="removePermission(item.id)"
                                    *ngIf="permissionObj.canDelete && item.created_by !== ''">
                                    <svg-icon src="assets/images/icon-trash.svg"></svg-icon>
                                </button>
                                <app-spacer [right]="16"></app-spacer>
 -->

                                <app-tooltip text="Visualizar" position="top">
                                    <button class="dash-item-button"
                                        (click)="redirectToDetails(item.id)">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"></svg-icon>
                                    </button>
                                </app-tooltip>

                                <app-spacer [right]="16"></app-spacer>

                                <app-tooltip
                                    [text]="item.status === 'Ativo' ? 'Inativar' : 'Ativar'"
                                    position="top"
                                    *ngIf="permissionObj.canInactive">
                                    <button class="dash-item-button"
                                        (click)="togglePermissionStatus(item.id)"
                                        [disabled]="loadingStatus">
                                        <svg-icon
                                            src="assets/images/icon-ban.svg"
                                            *ngIf="item.status === 'Ativo'"></svg-icon>
                                        <svg-icon
                                            src="assets/images/icon-check-filled.svg"
                                            *ngIf="item.status === 'Inativo'"></svg-icon>
                                    </button>
                                </app-tooltip>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="data.length === 0">
                        <td>Nenhum grupo de permissão encontrado</td>
                    </tr>

                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>

            <ng-container *ngIf="!loading && data.length === 0">
                <app-empty-content [isVisible]="true" [large]="true"
                    [title]="hasFilters ? 'Nenhum resultado encontrado' : 'Não há nenhum grupo de permissões para exibir'"
                    [description]="hasFilters ? 'Não encontramos nenhum grupo de permissões com os filtros aplicados. Tente ajustar os filtros ou limpar para ver todos os grupos.' : 'Não há grupos de permissões para serem exibidos no momento, para adicionar um novo grupo de permissões clique no botão abaixo.'"
                    icon="/assets/images/figure_3d_search.png"
                    (onClick)="addPermission()" [haveButtonIcon]="true"
                    [buttonLabel]="hasFilters ? undefined : 'Adicionar permissão'">
                </app-empty-content>
            </ng-container>
        </div>
    </div>
</div>

<div class="col-12 ml-auto mr-auto" *ngIf="data.length > 0">
    <div class="dash-card-pagination">
        <app-pagination [data]="data" [count]="count" [show]="!loading"
            [offset]="offset" (onPageChange)="changePageData($event)"
            [dashPagination]="true" [resultsPerPage]="results_per_page">
        </app-pagination>
    </div>
</div>

<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    [disableApplyButton]="!canApplyFilters" (onClose)="showFilterModal = false"
    (onApply)="filterData()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="name"
                placeholder="Digite" label="Grupo">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-select [items]="statusOptions" [group]="filterForm"
                controlName="status" placeholder="Selecione" label="Status">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="start_date"
                mask="00/00/0000" label="Data de início"
                placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="end_date"
                mask="00/00/0000" label="Data final" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>